/* ============================================================
   VIJG — Efectos editoriales (botones magnéticos)
   Aditivo y defensivo: si algo falla, no rompe la tienda.
   ============================================================ */
(function () {
  "use strict";
  try {
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var fine = window.matchMedia("(hover:hover) and (pointer:fine)").matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    /* Cursor personalizado ELIMINADO (24 jul): se quedaba pegado en
       pantalla como un círculo dorado fantasma cuando el navegador
       interrumpía el evento de salida del mouse (p.ej. al cambiar de
       color y refrescarse la foto), pareciendo una imagen encima de
       otra. Quitado por seguridad en vez de parchear. */

    /* ---------- BOTONES MAGNÉTICOS ---------- */
    if (fine && !reduce && !designMode) {
      var mags = document.querySelectorAll(".btn-primary, .btn-outline");
      mags.forEach(function (el) {
        el.addEventListener("mousemove", function (e) {
          var r = el.getBoundingClientRect();
          var x = (e.clientX - r.left - r.width / 2) * 0.22;
          var y = (e.clientY - r.top - r.height / 2) * 0.32;
          el.style.transform = "translate(" + x + "px," + y + "px)";
        });
        el.addEventListener("mouseleave", function () { el.style.transform = ""; });
      });
    }
  } catch (err) {
    /* si algo falla, la tienda sigue funcionando normal */
    if (window.console) console.warn("VIJG effects:", err);
  }
})();


/* ============================================================
   VIJG v7 — Rendimiento (24 jul 2026)
   Un solo MutationObserver compartido (antes había 3 corriendo
   por separado, cada uno re-escaneando toda la página en cada
   cambio del DOM). También corrige el autoplay de video para que
   no reproduzca de más: ahora exige más superficie visible antes
   de reproducir, y el chequeo inicial ya considera el eje
   horizontal (antes solo miraba arriba/abajo, así que en el
   carrusel de videos horizontal reproducía varios "de más" que
   en realidad estaban fuera de pantalla a los lados).
   ============================================================ */
(function () {
  "use strict";
  try {
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    /* ---------- 1) VIDEOS: autoplay silencioso, solo lo realmente visible ----------
       Los carruseles/marquesinas de video que vienen de apps (clases
       "ai-video-marquee...", "ai-video-carousel...", "designer-video",
       "designer-image-wrapper") ya traen su propio control de reproducción.
       Antes este script también los tocaba, y los dos controles se peleaban
       por el mismo video (uno lo pausaba justo cuando el otro lo mandaba a
       reproducir), lo que hacía que el navegador cancelara y volviera a
       descargar los mismos segundos de video una y otra vez — muchísimo
       peso desperdiciado. Ahora esos videos se dejan intactos, sin tocar
       nada de lo que ya está armado. */
    var esVideoDeApp = function (v) {
      return !!v.closest('[class*="ai-video-marquee"],[class*="ai-video-carousel"],[class*="designer-video"],[class*="designer-image-wrapper"]');
    };
    var prepVideo = function (v) {
      if (v.__vijgAuto) return;
      v.__vijgAuto = true;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute("muted", "");
      v.setAttribute("playsinline", "");
      v.loop = true;
      v.controls = false;
      v.preload = "none";
    };
    var tryPlayVideo = function (v) {
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    };
    var tryPauseVideo = function (v) {
      if (!v.paused) v.pause();
    };
    /* Pequeña espera antes de reaccionar: evita que un video se
       reproduzca y pause en cadena por temblores de la medición de
       visibilidad (p.ej. mientras algo se acomoda en pantalla). */
    var vijgVideoDebounce = new WeakMap();
    var videoIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        var pending = vijgVideoDebounce.get(v);
        if (pending) clearTimeout(pending);
        var visible = e.isIntersecting;
        vijgVideoDebounce.set(v, setTimeout(function () {
          if (visible) { prepVideo(v); v.preload = "auto"; tryPlayVideo(v); }
          else { tryPauseVideo(v); }
        }, 220));
      });
    }, { threshold: 0.45 });
    var scanVideos = function () {
      document.querySelectorAll("video").forEach(function (v) {
        if (esVideoDeApp(v)) return;
        prepVideo(v);
        if (v.__vijgIoObs) return;
        v.__vijgIoObs = true;
        videoIO.observe(v);
      });
    };

    /* ---------- 1b) FOTOS DE PRODUCTO: las que ya se ven al entrar a la
       página se piden primero y con prioridad alta. El tema las marca a
       todas por igual como "carga diferida / prioridad baja", así que las
       que el cliente ve de entrada quedaban compitiendo con todo lo demás
       (videos, scripts) en vez de ir primero. Solo se corrige la prioridad
       de descarga; no se cambia ninguna foto, texto ni diseño.
       IMPORTANTE: el grupo de fotos "prioritarias" se decide UNA sola vez,
       apenas carga la página (no según dónde esté el scroll en cada
       pasada posterior). Si esto se recalculara con cada pasada, un
       scroll automático de la página (como el aviso "¿Aún estás ahí?")
       terminaba marcando como "prioritarias" fotos de toda la página,
       incluyendo las pesadas — el efecto contrario al buscado. Se
       reafirma solo sobre ESE grupo fijo, por si el tema le vuelve a
       poner "carga diferida" poco después de cargar. ---------- */
    var vijgFotosPrioritarias = null;
    var priorizarFotosVisibles = function () {
      if (vijgFotosPrioritarias === null) {
        var limite = window.innerHeight * 1.3;
        vijgFotosPrioritarias = Array.prototype.filter.call(
          document.querySelectorAll(".product-item .product__media img"),
          function (img) {
            var r = img.getBoundingClientRect();
            return r.top < limite && r.bottom > 0;
          }
        );
      }
      vijgFotosPrioritarias.forEach(function (img) {
        if (img.getAttribute("loading") !== "eager") img.loading = "eager";
        if (img.getAttribute("fetchpriority") !== "high") img.setAttribute("fetchpriority", "high");
      });
    };

    /* ---------- 2) Respaldo elegante si una foto de producto falla,
       y aviso de "ya cargó" para apagar la animación de espera ---------- */
    var markLoaded = function (img) {
      var media = img.closest(".product__media");
      if (media) media.classList.add("vijg-loaded");
    };
    var bindImgFallback = function (img) {
      if (img.__vijgErrBound) return;
      img.__vijgErrBound = true;
      if (img.classList.contains("first-image") || img.matches(":only-of-type")) {
        if (img.complete && img.naturalWidth > 0) markLoaded(img);
        else img.addEventListener("load", function () { markLoaded(img); });
      }
      img.addEventListener("error", function () {
        var media = img.closest(".product__media");
        if (media && !media.classList.contains("vijg-img-fallback")) {
          media.classList.add("vijg-img-fallback");
          img.style.display = "none";
        }
      });
    };
    var scanImgFallback = function () {
      document.querySelectorAll(".product-item .product__media img").forEach(bindImgFallback);
    };

    /* ---------- 3) Inclinación 3D de tarjetas (solo escritorio) ---------- */
    var bindTilt = function (card) {
      if (card.__vijgTilt) return; card.__vijgTilt = true;
      var raf = null;
      card.addEventListener("mousemove", function (ev) {
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          card.classList.add("vijg-tilt");
          card.style.setProperty("--vijg-ry", (px * 6).toFixed(2) + "deg");
          card.style.setProperty("--vijg-rx", (-py * 6).toFixed(2) + "deg");
        });
      });
      card.addEventListener("mouseleave", function () {
        card.classList.remove("vijg-tilt");
        card.style.setProperty("--vijg-ry", "0deg");
        card.style.setProperty("--vijg-rx", "0deg");
      });
    };
    var scanTilt = function () {
      if (!fine || reduce) return;
      document.querySelectorAll(".product-item").forEach(bindTilt);
    };

    /* ---------- Escaneo combinado (una sola pasada para las 3 cosas) ---------- */
    var scanAll = function () {
      priorizarFotosVisibles();
      scanVideos();
      scanImgFallback();
      scanTilt();
    };
    scanAll();
    document.addEventListener("DOMContentLoaded", scanAll);
    window.addEventListener("load", scanAll);
    setTimeout(scanAll, 1500);
    setTimeout(scanAll, 4000);
    setTimeout(scanAll, 7000);
    setTimeout(scanAll, 10000);

    /* UN SOLO observer para todo el documento, con una pequeña espera
       (debounce) para no re-escanear decenas de veces seguidas cuando
       el DOM cambia mucho de golpe (p.ej. al cargar el carrito). */
    var debounceTimer = null;
    new MutationObserver(function () {
      if (debounceTimer) return;
      debounceTimer = setTimeout(function () { debounceTimer = null; scanAll(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });

    var kick = function () { scanAll(); document.removeEventListener("touchstart", kick); document.removeEventListener("scroll", kick); };
    document.addEventListener("touchstart", kick, { passive: true });
    document.addEventListener("scroll", kick, { passive: true });
  } catch (e) { }
})();


/* ============================================================
   VIJG v4 — Interactividad de impacto
   Defensivo: si algo falla, la tienda nunca queda rota.
   ============================================================ */
(function () {
  "use strict";
  try {
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* 1) Barra de progreso de lectura */
    if (!reduce) {
      var bar = document.createElement("div");
      bar.id = "vijg-progress";
      var addBar = function () { if (document.body && !document.getElementById("vijg-progress")) document.body.appendChild(bar); };
      addBar(); document.addEventListener("DOMContentLoaded", addBar);
      var onScroll = function () {
        var h = document.documentElement;
        var max = (h.scrollHeight - h.clientHeight) || 1;
        var pct = Math.min(100, Math.max(0, (h.scrollTop || window.pageYOffset) / max * 100));
        bar.style.width = pct + "%";
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      onScroll();
    }

    /* 2) Aparición al hacer scroll */
    if (!reduce && "IntersectionObserver" in window) {
      var revIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("vijg-in"); revIO.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      var tagReveal = function () {
        var sel = ".icon-box__item, [class*='icon_box'] > *, .product-showcase .product-item, footer .footer-block, .modern-collapsible, .contactformsimple2 [class*='info']";
        document.querySelectorAll(sel).forEach(function (el, i) {
          if (el.__vijgRev) return; el.__vijgRev = true;
          el.classList.add("vijg-reveal");
          el.style.transitionDelay = ((i % 6) * 70) + "ms";
          revIO.observe(el);
        });
      };
      tagReveal();
      document.addEventListener("DOMContentLoaded", tagReveal);
      setTimeout(tagReveal, 1200);
      /* Fallback duro: nada permanece oculto pasados 3.5s */
      setTimeout(function () {
        document.querySelectorAll(".vijg-reveal:not(.vijg-in)").forEach(function (el) { el.classList.add("vijg-in"); });
      }, 3500);
    }

    /* 3) Rebote del contador del carrito al agregar un producto
       (antes también sondeaba cada 700ms sin parar nunca; ahora
       solo reacciona al clic de "agregar", que es cuando de verdad
       hace falta). */
    if (!reduce) {
      var bumpEl = function (el) {
        if (!el) return; el.classList.remove("vijg-bump");
        void el.offsetWidth; el.classList.add("vijg-bump");
      };
      var findCartCount = function () {
        return document.querySelector('[class*="cart"] [class*="count"], [class*="cart-count"], [data-cart-count], .cart-link__bubble, [class*="bubble"]');
      };
      document.addEventListener("click", function (e) {
        var t = e.target.closest && e.target.closest('[name="add"], .product-form__submit, [class*="add-to-cart"], [class*="add_to_cart"]');
        if (t) setTimeout(function () { bumpEl(findCartCount()); }, 600);
        var heart = e.target.closest && e.target.closest('[class*="wishlist"], [class*="favorit"]');
        if (heart) { heart.classList.remove("vijg-heart"); void heart.offsetWidth; heart.classList.add("vijg-heart"); }
      }, true);
    }
  } catch (e) { /* nunca romper la tienda */ }
})();


/* ============================================================
   VIJG — Botón flotante de WhatsApp (24 jul 2026)
   Solo agrega; no toca nada existente.
   ============================================================ */
(function () {
  "use strict";
  try {
    var add = function () {
      if (document.getElementById("vijg-whatsapp-float") || !document.body) return;
      var a = document.createElement("a");
      a.id = "vijg-whatsapp-float";
      a.className = "vijg-whatsapp-float";
      a.href = "https://wa.me/573154138064?text=" + encodeURIComponent("Hola, tengo una pregunta sobre un producto de VIJG Fashion");
      a.target = "_blank";
      a.rel = "noopener";
      a.setAttribute("aria-label", "Escríbenos por WhatsApp");
      a.innerHTML = '<svg viewBox="0 0 32 32" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"><path d="M16.004 3C9.377 3 4 8.373 4 15c0 2.34.663 4.523 1.814 6.38L4 29l7.86-1.77A11.93 11.93 0 0 0 16.004 27C22.63 27 28 21.627 28 15S22.63 3 16.004 3zm0 21.7c-1.98 0-3.83-.55-5.41-1.5l-.39-.23-4.66 1.05 1.08-4.53-.25-.4A9.63 9.63 0 0 1 6.3 15c0-5.35 4.36-9.7 9.7-9.7 5.35 0 9.7 4.35 9.7 9.7 0 5.35-4.35 9.7-9.7 9.7zm5.32-7.26c-.29-.15-1.72-.85-1.99-.95-.27-.1-.46-.15-.66.15-.2.29-.76.95-.93 1.14-.17.2-.34.22-.63.08-.29-.15-1.23-.45-2.34-1.44-.86-.77-1.45-1.71-1.62-2-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.08-.15-.66-1.59-.9-2.18-.24-.57-.48-.5-.66-.5-.17 0-.37-.02-.56-.02-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44 0 1.43 1.04 2.82 1.19 3.01.15.2 2.05 3.13 4.96 4.39.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.11.55-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34z"/></svg>';
      document.body.appendChild(a);
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", add);
    } else {
      add();
    }
  } catch (e) { }
})();




